
export class BranchTagsMiniEntity {
  id?: number
  name?: string
  channelId?: number;
  channelName?: string;
  imageUrl?: string | null;
  isActive?: boolean;
} 
